import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { mq } from '../../../../../../common/src/utils/styledComponentsUtils';
import YesNoQuestion from '../../../ui/advisory-flow/components/shared-components/YesNoQuestion';
import { Box } from '@wegroup/design-system';

interface Props {
  handleYes: () => void;
  handleNo: () => void;
  showMobile?: boolean;
}

const VehicleDataYesNoButtons: React.FC<React.PropsWithChildren<Props>> = ({
  showMobile,
  handleYes,
  handleNo,
}) => {
  const { t } = useTranslation();
  return (
    <Box minW={{ base: '100%', laptop: '96' }}>
      <StyledYesNoQuest
        noText={t('No, I want to adjust')}
        handleYes={handleYes}
        handleNo={handleNo}
        showMobile={showMobile}
      />
    </Box>
  );
};

const StyledYesNoQuest = styled(YesNoQuestion)<{ showMobile?: boolean }>`
  display: ${({ showMobile }) => (showMobile ? 'flex' : 'none')};

  ${mq.laptop} {
    display: flex;
  }
`;

export default VehicleDataYesNoButtons;
